export enum PATHS {
  ACCOUNT = "/account",
  ACCESS_KEYS_DASHBOARD = "/access-keys",
  ACSES_LOGS_DASHBOARD = "/acses-logs",
  AGREEMENTS_DASHBOARD = "/agreements",
  APPOINTMENT_DETAIL = "/appointments/:id",
  APPOINTMENT_DETAIL_LOCATION_ID_WO_NR = "/appointments/:locationId/:woNr",
  APPOINTMENT_DETAIL_VIEW_BY_WO = "/appointments/view_by_wo",
  APPOINTMENTS = "/appointments",
  BACKORDERS_DASHBOARD = "/backorders",
  BRANDS_DASHBOARD = "/brands",
  CAR_DETAIL = "/cardetails",
  CHECK_IN_SERVICES_DASHBOARD = "/checkin-services",
  CAR_DETAILS = "/cardetails/:id",
  CHECKLIST_SETTINGS_DASHBOARD = "/checklist-settings",
  CHECKLISTS_DASHBOARD = "/checklists",
  COMMUNICATION_TEMPLATES = "/templates",
  CUSTOMER_COM = "/customer-com",
  CUSTOMERS_DASHBOARD = "/customers",
  DAYPLANNER = "/dayplanner",
  DEALER_DOCUMENTATION = "/dealer-documentation",
  DEALER_LICENSE_OVERVIEW = "/dealer-license-overview",
  DEALER_OVERVIEW_DASHBOARD = "/dealer-overview",
  DEALER_REPORTS = "/dealer-reports",
  DEALERS_DASHBOARD = "/dealers",
  DEALERS_DASHBOARD_DEALER = "/dealers/:dealerId",
  DEALERS_DASHBOARD_LOCATION = "/dealers/locations/:locationId",
  DEVICES_DASHBOARD = "/devices",
  DMS_CAPABILITIES_DASHBOARD = "/dms-capabilities",
  DMSV3_CUSTOM_QUERIES = "/dmsv3-custom-queries",
  DMSV3_SETTINGS = "/dmsv3-settings",
  DMSv3_MONITORING_DASHBOARD = "/DMSv3/monitoring",
  DPO_CONTRACT = "/dpo-contract",
  ENGAGEMENT_TEMPLATES = "/engagement-templates",
  EXACT_MONITORING = "/exact-monitoring-dashboard",
  FACTORY_EXPORTS_DASHBOARD = "/factory-exports",
  FORGOT_PASSWORD = "/forgot-password",
  HOLDING_APPOINTMENT_DETAIL = "/holding/appointments/:id",
  HOLDINGS_DASHBOARD = "/holdings",
  HOME = "/",
  INCOMPLETE_TYRES_DASHBOARD = "/incomplete-tyres",
  KIOSK_DASHBOARD = "/kiosk",
  KEYLOCKERS_DASHBOARD = "/key-lockers",
  LEADS_DASHBOARD = "/leads",
  LOCATION_LICENSE_OVERVIEW = "/location-license-overview",
  LOCATION_OVERVIEW_DASHBOARD = "/location-overview",
  LOCATION_REPORTS = "/location-reports",
  LOGIN = "/login",
  MANUFACTURER_DASHBOARD = "/manufacturer",
  NEWS_DASHBOARD = "/news",
  NOTES_MENU = "/notes-menu",
  PARKING_GATE_CODES_DASHBOARD = "/parking-gate-codes",
  PENDING_CHECKLISTS_DASHBOARD = "/pending-checklists",
  PRIVACY_AND_SECURITY_DASHBOARD = "/privacy-security",
  QUESTIONS_DASHBOARD = "/questions",
  REPORT_TEMPLATES_DASHBOARD = "/report-templates",
  RESET_PASSWORD = "/reset-password",
  RESET_PASSWORD_REQUEST = "/reset-password-request",
  SHAREBOX_DASHBOARD = "/sharebox-logs",
  STATUS_LIST_DASHBOARD = "/status-list",
  STYLE_GUIDE = "/styleguide",
  TAGS_DASHBOARD = "/tags",
  TYRES_DASHBOARD = "/tyres",
  USERS = "/users",
  THREE_DEPARTMENT_DASHBOARD = "/three-departments",
  TYRE_DISCOUNTS_DASHBOARD = "/tyre-discounts",
  UNLINKED_EXACT_LICENSES = "/unlinked-exact-licenses",
  WARRANTY_DASHBOARD = "/warranty",
  WEBHOOKS_DASHBOARD = "/webhooks"
}
